// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3-phQ","balanceDisclaimer":"posDashboard_balanceDisclaimer__1iJg_"};